export default function (_ref) {
  var value = _ref.value,
      defaultValue = _ref.defaultValue,
      valueType = _ref.valueType;
  var unitName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var transmitRatio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  function parseValue(value) {
    return Math.ceil(Number(value) * transmitRatio);
  }
  var r = String(value).split(':');
  var range = r[0].split('-');
  var result = {
    valueType: valueType,
    step: parseValue(r[1]),
    max: parseValue(range[1]),
    min: parseValue(range[0])
  };

  if (defaultValue) {
    result.value = parseValue(defaultValue);
  }
  if (result.min) {
    result.value = result.min;
  }
  result.unit = unitName;
  return result;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ali/common-cpq-constraint/es/convertRestriction/convertRangeFloat.js
// module id = 170
// module chunks = 0